import React from 'react';
import classes from './WhiteEmojiCard.module.scss'

interface Props {
    icon: string;
    text: string;
}

const WhiteEmojiCard = ({icon, text}:Props) => {
    return (
        <div className={classes.block}>
            <img className={classes.icon} alt='icon' src={require(`../../media/emoji/${icon}.svg`)}/>
            <span>{text}</span>
        </div>
    );
};

export default WhiteEmojiCard;